<template>
    <section class="font-poppins ">
        <div v-if="manageRider">
            <section class=" mt-10">
                <div class="text-sm flex justify-end md:flex-col">
                    
                    <div>
                        <input v-model="searchQuery" @click="search = !search" class="border outline-none w-72 p-2 rounded-lg bg-gray-100 text-xs" type="text" name="search" id="search" placeholder="Search name, email...">
                        <i class="fa fa-search -ml-8 md:hidden"></i>
                    </div>
                </div>
            </section>

            <section>
                <div>
                    <div class="flex text-sm pl-2 md:mt-2">
                        <router-link to="/pending-riders" class="text-blue-600 border p-2">Pending Carriers</router-link>
                        <router-link to="/approved-riders" class="text-blue-600 border ml-4 p-2">Approved Carriers</router-link>
                    </div>

                    <div class=" font-bold mt-4 flex">
                        <p>Riders List </p>
                        <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                    </div>
                </div>
            </section>

            <div class="text-sm md:overflow-x-auto">
                <table class="w-full mt-5">
                    <tbody>
                        <tr class="text-left  border-b-2">
                            <th>Carrier Name</th>
                            <th>Email</th>
                            <th>Gender</th>
                            <th>Location</th>
                            <th>DSO</th>
                            <!-- <th>Rating</th> -->
                            <th>Status</th>
                            <th>Order Date</th>
                        </tr>
                        
                        <tr v-for="rider in filterName" :key="rider.id" class="hover:bg-gray-300 hover:border  hover:border-blue-700 p-2 border-b-2">
                            <td>{{rider.firstName}} {{rider.lastName}}</td>
                            <td class="text-blue-700 p-1">{{rider.email}}</td>
                            <td>{{rider.gender}}</td>
                            <td>{{rider.country}}, {{rider.state}}</td>
                            <td>{{rider.dsoId}}</td>
                            <!-- <td><star-rating :star-size="10"></star-rating></td> -->
                            <td>
                                <span v-if="rider.status === 'blocked'" class="blocked"><i class="fa fa-circle mr-2"></i>{{rider.status}}</span> 
                                <span v-if="rider.status === 'approved'" class="approved"><i class="fa fa-circle mr-2"></i>{{rider.status}}</span> 
                                <span v-if="rider.status === 'deleted'" class="deleted"><i class="fa fa-circle mr-2"></i>{{rider.status}}</span> 
                                <span v-if="rider.status === 'pending'" class="pending"><i class="fa fa-circle mr-2"></i>{{rider.status}}</span>
                                <span v-if="rider.status === 'available'" class="available"><i class="fa fa-circle mr-2"></i>{{rider.status}}</span> 

                            </td>
                            <td>{{moment(rider.dateRegistered).format('DD/MM/YYYY')}} <span @click="toggleList(rider)" class=" fa fa-ellipsis-v ml-3 text-gray-500 cursor-pointer"></span>
                            <div class=" relative">
                                <ul class="absolute right-5 text-xs bg-gray-50 pt-4 pb-4 pl-2 pr-2" v-show="rider.navList">
                                    <router-link :to="{name: 'riders-info', params: {id: rider.email}}">
                                        <li class="border-b-2 cursor-pointer">View Information</li>
                                    </router-link> 
                                    <router-link :to="{name: 'email-center', params: {id:rider.email}}"><li class="mt-2 border-b-2  cursor-pointer">Message</li></router-link>
                                    <li  v-if=" rider.status === 'approved' || rider.status === 'active' || rider.status === 'unavailable' " class="mt-2 border-b-2  cursor-pointer" @click="blockRider(rider)">Block Carrier</li>
                                    <li v-show="rider.status ==='blocked'" class="mt-2 border-b-2  cursor-pointer" @click="unblockRider(rider)">Unblock Carrier</li>
                                    <li class="mt-2 border-b-2 cursor-pointer" @click="deleteRiderModal(rider)">Delete Carrier</li>
                                </ul>
                            </div></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="!searchQuery" class="flex justify-between mt-10 text-gray-500 md:flex-col">
                <div>
                    <p>Showing {{currentPage}} of {{totalPages}} Pages of {{totalList}} Carriers </p>

                </div>

                <div class="flex">
                    <button @click="prev" class="border w-24 text-center text-blue-600  border-blue-600"> <i class="fa fa-angle-left mr-2"></i>Previous </button>
                    <button @click="next" class="border w-24 text-center border-blue-600 text-blue-600 ml-1">Next <i class="fa fa-angle-right ml-2"></i></button>
                </div>
            </div>
        </div>

        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeModal"
            :message="message"
            @getRiders="getRiders"
            :riderId="riderId"
            />
        </div>

    </section>
</template>


<script>
import axios from 'axios';
import moment from 'moment';
import {baseUrl} from '../../../Config';
const url = baseUrl;
import DeleteModal from './DeleteModal.vue';
export default {
    components: {DeleteModal},
    data() {
        return {
            filter: '',
            navList: null,
            riderInfo: false,
            manageRider: true,
            pendingRiders: false,
            riders : [],
            page : 1,
            blockStatus : "blocked",
            unblockStatus : "approved",
            delete: "deleted",
            search: null,
            selectedName: null,
            showFilter: true,
            searchQuery : '',
            isLoading : false,
            currentList: "",
            totalList: "",
            deleteModal: false,
            message: "",
            riderId: "",
            currentPage:1,
            pageSize:20,
            searchLength: "",
            totalPages: "",
        }
    },

    computed: {
        filterName() {
            const query = this.searchQuery.toLowerCase()
            if(this.searchQuery) {
               return this.riders.filter((theOrder) => {  
                     return Object.values(theOrder).some((word) => String(word).toLowerCase().includes(query))
                })
            }  else {
                return this.riders.filter((row, index) => {
                let start = (this.currentPage -1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                let totalPages = this.riders.length / this.pageSize
                this.totalPages = Math.round(totalPages)
                if(this.totalPages == 0) {
                    this.totalPages = 1
                }
                if(index >= start && index < end) return true;
                })
            }
        }
    },

    mounted() {
        this.getRiders();
        this.networkError();
    },

    methods: {
        moment(date) {
            return moment(date);
        },

        closeModal() {
            this.deleteModal = false;
        },
        deleteRiderModal(rider) {
            this.riderId = rider.riderId
            rider.navList = !rider.navList
            this.deleteModal = true;
            this.message =  "Are you sure you want to perform this action?"
        },

        showDetails(eachUser) {
            this.selectedName = eachUser;
            this.showFilter = false
            this.getRiders()
        },

         next() {
            if((this.currentPage*this.pageSize) < this.riders.length) this.currentPage++;
        },

        prev() {
            if(this.currentPage > 1) this.currentPage--
        },

        toggleList(rider) {
            rider.navList = !rider.navList
        },

        showRiderInfo() {
            this.riderInfo = true;
            this.manageRider = false
        },

        showPendingRiders() {
            this.ri
            this.pendingRiders = true
            this.manageRider = false
        },

        getRiders() {
            this.isLoading = true
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.riders = response.data.data.results;
                this.currentList = this.riders.length;
                this.totalList = response.data.data.meta.totalResults;
                this.isLoading = false;
            })
            .catch((error) => {
                console.log(error)
            })
            
        },

        blockRider(rider) {
            rider.navList = !rider.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${rider.riderId}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.blockStatus
                }
            })
            .then((response) => {
                this.getRiders()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        unblockRider(rider) {
            rider.navList = !rider.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${rider.riderId}`,
                headers: {
                    Authorization: 'Bearer' + localStorage.getItem('token'),
                    'Content-type': 'application/json',
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.unblockStatus
                }
            })
            .then((response) => {
                this.getRiders()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        deleteRider(rider) {
            rider.navList = !rider.navList
            axios({
                method: 'PUT',
                url: `${url}/v1/web/riders/update/status/${rider.riderId}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.delete
                }
            })
            .then((response) => {
                this.getRiders()
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }

        
    }
}
</script>

<style scoped>
.pending {
    color: rgb(243, 243, 9);
}
.deleted {
    color: red;
}

.approved{color: green;}
.available{color: royalblue;}
.blocked{color:red}
</style>